export default function () {
    if (!document.querySelector('.layout_categoryoverview') && !document.querySelector('.layout_categorydetail')) {
        return;
    }

    // load all category teasers on click on "Weitere Themen anzeigen" and hide button
    $('.load-more').click(() => {
        $('.blog__categories .teaser-container.hidden').removeClass('hidden');
        $('.load-more').hide();
    });

    // initialize slider for Top News on mobile
    new Glide('.blog__topnews__slider', {
        type: 'carousel',
        startAt: 0,
        perView: 3,
        gap: 30,
        breakpoints: {
            769: {
                perView: 1,
            },
        },
    }).mount();
}
